export default __webpack_public_path__ + "932e8af1f3f45b033a91756fe075fa81.png";